import { appPaths, type AppPath } from "../appPaths.js";

interface PerformanceSection {
  label: string;
  path: AppPath<`/performance/playbooks/:playbookId/${string}`>;
}

/**
 * The performance workspace's sections, defined once so the left-nav menu and
 * the breadcrumb trail can't drift apart on labels or targets.
 */
export const performanceSections = {
  overview: { label: "Overview", path: appPaths.playbookDashboard },
  team: { label: "Team", path: appPaths.playbookTeammates },
  calls: { label: "Calls", path: appPaths.playbookCalls },
  playbook: { label: "Playbook", path: appPaths.playbookCriteria },
  agents: { label: "Agents", path: appPaths.playbookAgents },
  topics: { label: "Topics", path: appPaths.playbookTopics },
  signals: { label: "Signals", path: appPaths.playbookSignals },
  reports: { label: "Reports", path: appPaths.playbookReports },
} as const satisfies Record<string, PerformanceSection>;
